function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null);

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "Rename_svg__a",
  d: "M4.095 1.003L0 11.426h1.675l.834-2.233h4.653l.834 2.233h1.675L5.584 1.003zm-1.028 6.7L4.839 2.99l1.772 4.713zM9.764 14v-1.274h3.182V1.272H9.764V0h7.635v1.272h-3.181v11.454h3.181V14z"
});

function SvgRename(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.399 14"
  }, props), _ref, _ref2);
}

export default SvgRename;